import { Box, FormControl, FormHelperText, InputLabel, useTheme } from '@mui/material';
import React from 'react';
import Select, {components as comp} from 'react-select';
import './customselect.css'

const ValueContainer = ({ children, ...props }) => {
  const { leftIcon, leftIconPress, leftIconBoxStyle } = props.selectProps;
  return (
    comp.ValueContainer && (
      <comp.ValueContainer {...props}>
        {!!children && (
         <Box sx={{position: 'absolute', top: 18, left: 10, ...leftIconBoxStyle}} {...(leftIconPress? {onClick: leftIconPress}:{})}>
           {leftIcon}
         </Box>
        )}
        {children}
      </comp.ValueContainer>
    )
  );
};


const components = {
  IndicatorSeparator: null,
  ValueContainer
};
const CustomSelect = React.forwardRef(({
  width,
  handleChange,
  promiseOptions,
  error,
  helperText,
  name,
  controlStyle,
  dropDownZIndex,
  label,
  labelShrink,
  labelStyle={},
  placeholderStyle={},
  formControlClass="",
  inputLabelClass="",
  selectClass="",
  InputLabelProps={},
  leftIcon,
  leftIconPress,
  leftIconBoxStyle={},
  ...props
}, ref) => {
  const theme = useTheme();
  let errorStatus = error?.constructor === Object? name ? error[name] : null : error ? error : false;
  return (
    <div style={{ width: width || 450 }}>
      <FormControl
        required
        error={errorStatus}
        sx={{
          width: '100%'
        }}
        component="fieldset"
        variant="standard"
        className={`${formControlClass} ${errorStatus? 'is-error' : ""}`}
      >
        <InputLabel className={inputLabelClass} shrink={labelShrink} sx={{zIndex: 1, top: -6, left:10, padding: '0 6px' , background: "#fff", ...labelStyle}} required={props.required} {...InputLabelProps}>{label}</InputLabel>
        
        <Select
            className={`basic-single ${selectClass} ${errorStatus? 'is-error' : ""}`}
            classNamePrefix="select"
            cacheOptions
            defaultOptions
            onChange={handleChange}
            menuPortalTarget={document.body}
            leftIcon={leftIcon}
            leftIconPress={leftIconPress}
            leftIconBoxStyle={leftIconBoxStyle}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: dropDownZIndex, minWidth: 185 }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: errorStatus ? '#d32f2f' : state.isFocused
                  ? theme.palette.appColor.contrastText
                  : theme.palette.appColor.contrastText,
                borderWidth: selectClass.includes('dark') ? '0px' :state.isFocused ? '2px' : '1px',
                boxShadow: '0 0 0 0',
                borderRadius: theme.shape.borderRadius(3),
                padding: 1.5,
                ...controlStyle
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                ...placeholderStyle
              }),
              valueContainer: base => ({
                ...base,
                ...(leftIcon ? {paddingLeft: 40}: {})
              })
            }}
            components={components}
            maxMenuHeight={200}
            menuPlacement={'auto'}
            {...props}
            ref={ref}
        />
         {error?.constructor === Object ? (helperText && error[name]) ? <FormHelperText>{helperText}</FormHelperText>: null : (helperText && error) ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControl>
    </div>
  );
})

export default React.memo(CustomSelect);

CustomSelect.defaultProps = {
  promiseOptions: () => [],
  width: 450,
  dropDownZIndex: 100,
  handleChange: () => {},
  label: "",
  labelShrink: false,
  required: false
};

